import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { buildCheckWindow, isNewBuildDeployed } from '../helpers/build-helper';

const TICK_MS = 60 * 1000;

// Reloads on the next route change rather than when the new build is found, so a half-filled
// form is never thrown away; navigating away from it already does that.
const useReloadOnNewBuild = () => {
  const { pathname } = useLocation();
  const newBuildDeployed = useRef(false);

  useEffect(() => {
    // The page just loaded the deployed build, so the window it opened in needs no check.
    let checkedWindow = buildCheckWindow();

    const check = async () => {
      const current = buildCheckWindow();
      if (newBuildDeployed.current || current === checkedWindow) return;
      checkedWindow = current;
      if (await isNewBuildDeployed()) newBuildDeployed.current = true;
    };
    // A sleeping laptop or a frozen background tab misses ticks, so catch up as soon as it's back.
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') check();
    };

    const interval = window.setInterval(check, TICK_MS);
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  useEffect(() => {
    if (newBuildDeployed.current) window.location.reload();
  }, [pathname]);
};

export default useReloadOnNewBuild;
